import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import RootRedirect from '../components/feature/RootRedirect';

const HomePage = lazy(() => import('../pages/home/page'));
const LatviaPage = lazy(() => import('../pages/latvia/page'));
const LatviaDetailPage = lazy(() => import('../pages/latvia-detail/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PartnershipPage = lazy(() => import('../pages/partnership/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog/detail'));
const ChoHemPage = lazy(() => import('../pages/cho-hem/page'));
const CustomerLoginPage = lazy(() => import('../pages/customer/login/page'));
const CustomerDashboardPage = lazy(() => import('../pages/customer/dashboard/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminCustomersPage = lazy(() => import('../pages/admin/customers/page'));
const AdminAccountsPage = lazy(() => import('../pages/admin/accounts/page'));
const AdminStaffPage = lazy(() => import('../pages/admin/staff/page'));
const CaseDetailPage = lazy(() => import('../pages/admin/case-detail/page'));
const AdminSetupPage = lazy(() => import('../pages/admin/setup/page'));
const NewCasePage = lazy(() => import('../pages/admin/new-case/page'));
const StepTemplatesPage = lazy(() => import('../pages/admin/step-templates/page'));

const routes: RouteObject[] = [
  // Root redirect
  {
    path: '/',
    element: <RootRedirect />,
  },

  // ============ CUSTOMER PORTAL ============
  {
    path: '/customer/login',
    element: <CustomerLoginPage />,
  },
  {
    path: '/customer/dashboard',
    element: <CustomerDashboardPage />,
  },

  // ============ ADMIN PORTAL ============
  {
    path: '/admin/setup',
    element: <AdminSetupPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/customers',
    element: <AdminCustomersPage />,
  },
  {
    path: '/admin/customers/new',
    element: <NewCasePage />,
  },
  {
    path: '/admin/customers/:id',
    element: <CaseDetailPage />,
  },
  {
    path: '/admin/accounts',
    element: <AdminAccountsPage />,
  },
  {
    path: '/admin/staff',
    element: <AdminStaffPage />,
  },
  {
    path: '/admin/step-templates',
    element: <StepTemplatesPage />,
  },

  // ============ VIETNAMESE ROUTES (/vi) ============
  {
    path: '/vi',
    element: <HomePage />,
  },
  {
    path: '/vi/dich-vu-xuat-khau',
    element: <HomePage />,
  },
  {
    path: '/vi/cho-hem',
    element: <ChoHemPage />,
  },
  {
    path: '/vi/dinh-cu-latvia',
    element: <LatviaPage />,
  },
  {
    path: '/vi/dinh-cu-latvia/chi-tiet',
    element: <LatviaDetailPage />,
  },
  {
    path: '/vi/dinh-cu-latvia/hop-tac',
    element: <PartnershipPage />,
  },
  {
    path: '/vi/dinh-cu-latvia/blog',
    element: <BlogPage />,
  },
  {
    path: '/vi/dinh-cu-latvia/blog/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/vi/ve-chung-toi',
    element: <AboutPage />,
  },
  {
    path: '/vi/lien-he',
    element: <ContactPage />,
  },

  // ============ ENGLISH ROUTES (/en) ============
  {
    path: '/en',
    element: <HomePage />,
  },
  {
    path: '/en/export-services',
    element: <HomePage />,
  },
  {
    path: '/en/cho-hem',
    element: <ChoHemPage />,
  },
  {
    path: '/en/immigration-latvia',
    element: <LatviaPage />,
  },
  {
    path: '/en/immigration-latvia/detail',
    element: <LatviaDetailPage />,
  },
  {
    path: '/en/immigration-latvia/partnership',
    element: <PartnershipPage />,
  },
  {
    path: '/en/immigration-latvia/blog',
    element: <BlogPage />,
  },
  {
    path: '/en/immigration-latvia/blog/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/en/about-us',
    element: <AboutPage />,
  },
  {
    path: '/en/contact',
    element: <ContactPage />,
  },

  // ============ LATVIAN ROUTES (/lv) ============
  {
    path: '/lv',
    element: <HomePage />,
  },
  {
    path: '/lv/eksporta-pakalpojumi',
    element: <HomePage />,
  },
  {
    path: '/lv/cho-hem',
    element: <ChoHemPage />,
  },
  {
    path: '/lv/latvija',
    element: <LatviaPage />,
  },
  {
    path: '/lv/latvija/detalizeti',
    element: <LatviaDetailPage />,
  },
  {
    path: '/lv/latvija/partneriba',
    element: <PartnershipPage />,
  },
  {
    path: '/lv/latvija/blogs',
    element: <BlogPage />,
  },
  {
    path: '/lv/latvija/blogs/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/lv/par-mums',
    element: <AboutPage />,
  },
  {
    path: '/lv/kontakti',
    element: <ContactPage />,
  },

  // ============ OLD ROUTES (Backward Compatibility) ============
  // Redirect to Vietnamese version by default
  {
    path: '/cho-hem',
    element: <RootRedirect />,
  },
  {
    path: '/dinh-cu-latvia',
    element: <RootRedirect />,
  },
  {
    path: '/dinh-cu-latvia/chi-tiet',
    element: <RootRedirect />,
  },
  {
    path: '/dinh-cu-latvia/blog',
    element: <RootRedirect />,
  },
  {
    path: '/dinh-cu-latvia/blog/:slug',
    element: <RootRedirect />,
  },
  {
    path: '/ve-chung-toi',
    element: <RootRedirect />,
  },
  {
    path: '/dinh-cu-latvia/hop-tac',
    element: <RootRedirect />,
  },
  {
    path: '/lien-he',
    element: <RootRedirect />,
  },

  // 404 Not Found
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;